window.addEventListener('DOMContentLoaded', function () {

	//VIDEO CREATE
	const videoWrap = document.querySelectorAll('.js-video')

	videoWrap.forEach(item => {
		const buttonPlay = item.querySelector('.video__play');
		let video = null;

		buttonPlay.addEventListener('click', () => {
			let currentVideo = document.querySelector('.js-video.is-playing');
			if (currentVideo) {
				currentVideo.classList.remove('is-playing');
				currentVideo.querySelector('video').pause();
			}

			if (!video) {
				const videoSrc = item.dataset.video;
				video = document.createElement('video');
				video.src = videoSrc;
				video.controls = true;
				video.autoplay = true;

				const videoContainer = item.querySelector('.video__container');
				videoContainer.innerHTML = '';
				videoContainer.append(video);

				item.classList.add('is-playing');

				video.addEventListener('pause', function () {
					videoStop(video, item);
				});

				video.addEventListener('ended', function () {
					videoStop(video, item);
				});
			} else {
				if (video.paused) {
					video.play();
					videoPlay(video, item);
				} else {
					video.pause();
					videoPlay(video, item);
				}
			}
		});
	})



	function videoStop(video, videoWrap) {
		video.controls = false;
		videoWrap.classList.remove('is-playing');
	}

	function videoPlay(video, videoWrap) {
		video.controls = true;
		videoWrap.classList.add('is-playing');
	}

});